import React from "react";
import Icon from "../Icon/Icon";

export const IconButton = ({
  iconName,
  textLeft = false,
  textRight = false,
  text = "",
  iconClassName,
  ...props
}) => {
  return (
    <button {...props}>
      {textLeft && text}
      <Icon name={iconName} className={iconClassName} />
      {textRight && text}
    </button>
  );
};
